/*
* @Author: 炫佑科技
* @Date: 2025-02-05 17:43:36
* @LastEditTime: 2025-02-07 10:33:03
* @LastEditors: 小轩
* @Description: 
* @FilePath: \card-consignment\kefu\src\api\app.js
* 炫佑科技-www.sdxuanyou.com
*/
import request from '@/plugins/axios'
import {terminal} from '@/utils/enum'

// 登录
export const apiLogin = data => request.post('/tenantapi/kefu.auth/account', {...data, terminal})

// 退出登录
export const apiLogout = () => request.post('/kefu/login/logout')


// 用户列表
export const apiChatUserList = params => request.get('/kefu/chat/user', {params})

// 聊天记录
export const apiChatHistory = params => request.get('/kefu/chat/record', {params})

//用户浏览记录
export const apiUserLookRecord = data => request.post('/tenantapi/kefu.kefu/recordlists', data)

// 客服列表
export const apiServiceList = params => request.get('/kefu/chat/online', {params})

//获取在线客服列表
export const apiOnLineKefuList = data => request.post('/tenantapi/kefu.kefu/getAllOnlineKefu', data)

//客服改价
export const apiServiceMoney = data => request.post('/tenantapi/kefu.kefu/changePrice', data)

//客服发送订单消息
export const apiServiceSendOrderMsg = data => request.post('/tenantapi/kefu.kefu/sendOrderMsg', data)

//客服发送订单咨询
export const apiServiceSendGoodsMsg = data => request.post('tenantapi/kefu.kefu/sendGoodsMsg', data)

//客服发送链接跳转
export const apiServiceSendLinkMsg = data => request.post('tenantapi/kefu.kefu/sendLinkMsg', data)

//客服确认完结交易
export const ConfirmOrder = data => request.post('tenantapi/kefu.kefu/ConfirmOrder', data);


// 快捷回复
export const apiReplyList = params => request.get('tenantapi/kefu.kefu/chatReply', {params})


// 获取用户详情
export const apiUserInfo = params => request.get('/kefu/chat/userInfo', {params})

// 获取订单列表
export const apiUserOrder = params => request.get('/kefu/chat/order', {params})

//用戶搜索
export const apiUserSerchById = data => request.post('/tenantapi/kefu.kefu/customer', data)

// 文件上传
export const apiUploadFile = data => request.post('/tenantapi/upload/image', data)

// 获取客服详情
export const apiKefuDetail = () => request.get('/kefu/chat/kefuInfo')

// 获取配置信息
export const apiGetConfig = () => request.get('/kefu/chat/config')
export const apiaddRecord = data => request.post('/kefu/chat/addRecord', data)

// export const userInfo = data => request.post('/tenantapi/kefu.kefu/userInfo', data)

// 会话列表
export const userList = data => {
    if(data.type!=undefined) data.url+='&type='+data.type;
    if(data.deal_status!=undefined) data.url+='&deal_status='+data.deal_status;
    return request.get('/tenantapi/kefu.kefu/lists?' + data.url, data)
}

// 聊天信息
export const chatList = data => request.post('/tenantapi/kefu.kefu/messgetLists?' + data.url, data)

// 获取客服信息
export const getKefu = data => request.post('/tenantapi/kefu.kefu/userInfo', data)

// 发送信息
export const sendChat = data => request.post('/tenantapi/kefu.kefu/send', data)

// 未读消息提醒
export const msgTip = data => request.post('/tenantapi/kefu.kefu/sendMsgTip', data)

export const customer = data => request.post('/tenantapi/kefu.kefu/customer', data)


export const orderList = data => {
    return request.post('/tenantapi/kefu.kefu/orderLists?' + data.url, data.data)
}

export const Read = data => request.post('/tenantapi/kefu.kefu/Read', data)

//撤回消息
export const recallMessageFn = data => request.post('/tenantapi/kefu.kefu/recall', data)

//根据商品id获取详情
export const getGoodsInfoById = data => request.post('/tenantapi/kefu.kefu/getGameAccountDetail', data)

//转接客服
export const transferKefu = data => request.post('/tenantapi/kefu.kefu/transferKefu', data)

//客服同意 拒绝买家的砍价
export const bargainPrice = data => request.post('/tenantapi/kefu.bargain/sellerReviewBargain', data)

//客服还价
export const sellerDickerBargain = data => request.post('/tenantapi/kefu.bargain/sellerDickerBargain', data)

//群组订单交易进度
export const getOrderProgress = data => request.post('/tenantapi/kefu.kefu/getOrderProgress', data)

//确认消息
export const confirmMessage = data => request.post('/tenantapi/kefu.kefu/confirmMessage', data)

//发送账号
export const inputAccount = data => request.post('/tenantapi/kefu.kefu/inputAccount', data)


//查看审核
export const reviewInfo = data => request.post('/tenantapi/kefu.kefu/reviewInfo', data)

//驳回审核
export const refuseInfo = data => request.post('/tenantapi/kefu.kefu/refuseInfo', data)

//通过审核
export const acceptInfo = data => request.post('/tenantapi/kefu.kefu/acceptInfo', data)

//重发换绑确认
export const resendBindProgress = data => request.post('/tenantapi/kefu.kefu/resendBindProgress', data)

//客服取消交易
export const cancelDeal = data => request.post('/tenantapi/kefu.kefu/cancelDeal', data)

//修改审核信息
export const saveReviewInfo = data => request.post('/tenantapi/kefu.kefu/saveReviewInfo', data)

//全员禁言
export const banGroup = data => request.post('/tenantapi/kefu.kefu/banGroup', data)

//关闭全员禁言
export const debanGroup = data => request.post('/tenantapi/kefu.kefu/debanGroup', data)

//打电话
export const callTip = data => request.post('/tenantapi/kefu.kefu/callTip', data)

//发短信
export const smsTip = data => request.post('/tenantapi/kefu.kefu/smsTip', data)

//星标客户
export const starThread = data=> request.post('/tenantapi/kefu.kefu/starThread', data)

//获取用户优惠券详情
export const getCouponDetail = data=> request.post('/tenantapi/kefu.kefu/getCouponDetail', data)

//获取客服可发优惠券列表
export const getCouponLists = data=> request.post('/tenantapi/kefu.kefu/getCouponLists'+data.url, data.data)

//发放用户优惠券
export const sendCoupon = data=> request.post('/tenantapi/kefu.kefu/sendCoupon', data)

//议价列表
export const getBargainList = data=> request.post('/tenantapi/kefu.kefu/getBargainList'+data.url, data)

//议价未处理数量
export const getBargainCount = data=> request.post('/tenantapi/kefu.kefu/getBargainCount'+data.url, data)

//客服接待统计
export const getTodayEff = data=> request.post('/tenantapi/kefu.kefu/getTodayEff', data)

//获取所有游戏信息
export const getGames = data=> request.get('/tenantapi/kefu.kefu/getGames', data)

//添加群成员前确认
export const checkUserInfo  = data=> request.post('/tenantapi/kefu.kefu/getMemebrInfo',data);
//添加群成员
export const addGroupMember = data=> request.post('/tenantapi/kefu.kefu/addGroupMember',data);
